import React from "react";
import { connect } from "react-redux";
import { useAdHocSearch } from "../../hooks/useAdHocSearch";

/**
 * Persistent component that maintains WebSocket connection for ad hoc search
 * even when navigating between pages. This ensures results aren't lost when
 * the user is on the create page or other routes.
 */
const AdHocSearchConnection = ({ adHocSearchJobId }) => {
  // Maintain WebSocket connection as long as jobId exists
  useAdHocSearch(adHocSearchJobId, {
    autoConnect: !!adHocSearchJobId,
  });

  // This component doesn't render anything - it's just for side effects
  return null;
};

const mapStateToProps = (state) => ({
  adHocSearchJobId: state.restaurant.adHocSearchJobId,
});

export default connect(mapStateToProps)(AdHocSearchConnection);


